var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import './clipped-image.scss';
export default function ClippedImage(_a) {
    var { className, src, alt } = _a, positionArgs = __rest(_a, ["className", "src", "alt"]);
    const style = Object.assign({ backgroundImage: `url(${src})` }, positionArgs);
    const titleOrHidden = alt ? { title: alt } : { 'aria-hidden': true };
    return (React.createElement("div", Object.assign({ className: cn(className, 'clipped-image'), style: style }, titleOrHidden)));
}
